import { FEATURE_FLAGS } from './FeatureFlags';

import { useFeature } from '.';

export const useIsFeatureFlagEnabled = (featureKey: FEATURE_FLAGS) => {
  const feature = useFeature(featureKey);

  return feature.on;
};
